export enum CourseStatus {
  PUBLISH = "PUBLISHED",
  DRAFTED = "DRAFTED",
}
